import type { UIElementRendererProvider, SupabaseUIElementInstance, UIElementDeletion } from '@/modules/uiElements/types';
import type { RendererBridge } from '@/modules/rendererBridge';
import { uiElementInstanceFromLegacy, type LegacyUiElementInstance } from '@/infrastructure/api/v1/mappers/uiElementInstances';

/** Tells the renderer about screen UI elements over the bridge, in the v1 shape the save returned. */
export class UIElementBridgeAdapter implements UIElementRendererProvider {
  constructor(private readonly bridge: RendererBridge) {}

  uiElementAdded(row: SupabaseUIElementInstance): void {
    this.bridge.send({ type: 'uiElementInstanceAdded', uiElementInstance: uiElementInstanceFromLegacy(row as unknown as LegacyUiElementInstance), restored: false });
  }

  uiElementUpdated(row: SupabaseUIElementInstance): void {
    this.bridge.send({ type: 'uiElementInstanceUpdated', uiElementInstance: uiElementInstanceFromLegacy(row as unknown as LegacyUiElementInstance) });
  }

  async uiElementDeleted(instanceId: string, deletion: UIElementDeletion | null): Promise<void> {
    if (!deletion) {
      this.bridge.send({ type: 'uiElementInstanceRemoved', uiElementInstanceUniqueId: instanceId });
      return;
    }
    // Its trigger responses went with it, so they leave the renderer and the editor too, unless another scene opened meanwhile
    const { currentScene, liveSceneSync } = await import('@/modules/undoRedo/scenePorts');
    const sceneId = currentScene();
    await liveSceneSync(this.bridge, () => currentScene() === sceneId).hideDeletion(deletion);
  }
}
